module.exports = __webpack_public_path__ + "static/img/gift-12.709d648.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-12.png
// module id = 356
// module chunks = 140